import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

class Loading extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        loading: true,
        text: ''
    };

    static propTypes = {
        loading: PropTypes.bool, // 是否展示loading
        text: PropTypes.string, // loading文案
    };

    componentDidMount() {
    }


    render() {
        const {
            loading,
            text
        } = this.props;

        return (
            <div className={`${loading ? '' : 'hide'} ${styles.loadingWrap}`}>
                <div className={styles.loadingIcon}/>
                {
                    text && <div className={styles.loadingText}>{text}</div>
                }
            </div>
        )
    }
}
export default Loading;